import { FilterPanel } from '@ecosystem/newron-client-lib';
import React, { useEffect, useState } from 'react';
import { ContextManager } from '../../context/manager';
import { Loading } from '../../design/loading/Loading';
import { useCorePageState } from '../../page/provider';
import { Context, CustomFeatureDetails, Params } from '../../types';
import { EditTrayComponent } from './price/customPriceTray';
import { FeatureEditTrayComponent } from './features/customFeatureTray';
import { TrayType } from '../../types/content/custom.types';
import { DEFAULT_QUANTITY } from '../../elements/constants';

interface TrayComponentProps {
  updateSettings: (updates: Params) => void;
  trayType?: TrayType;
}

function EditTray({ updateSettings }: TrayComponentProps) {
  const [context, setContext] = useState<Context>();
  const [currency, setCurrency] = useState<string>();
  const [quantityType, setQuantityType] = useState<string>(DEFAULT_QUANTITY);
  const [contextCustomFeature, setContextCustomFeature] = useState<CustomFeatureDetails>();
  const { trayType, page } = useCorePageState();

  useEffect(() => {
    const subscriber = (context: Context) => {
      if (context) {
        setContext(context);
      }
      if (context?.settings?.values?.resolvedLocalCurrency) {
        setCurrency(context.settings.values.resolvedLocalCurrency[0].value);
      }
      if (context?.settings?.values?.quantity_type) {
        setQuantityType(context.settings.values.quantity_type[0].value);
      }
      if (context.customFeature) {
        // Get the active custom feature menu
        const activeMenu = ContextManager.getInstance().getActiveCustomFeatureMenu();
        const pageCustomFeatures = context.customFeature?.[page.name];

        if (pageCustomFeatures && activeMenu) {
          // Get the context specific to the active menu
          const menuContext = pageCustomFeatures[activeMenu];
          setContextCustomFeature(menuContext);
        } else {
          setContextCustomFeature(undefined);
        }
      }
    };
    ContextManager.getInstance().subscribeToSettingsChanges(subscriber);
    return () => ContextManager.getInstance().unsubscribeFromSettingsChanges(subscriber);
  }, []);

  useEffect(() => {
    return () => {
      ContextManager.getInstance().setActiveCustomFeatureMenu(null);
    };
  }, [page.name]);

  if (!context?.filters) {
    return (
      <FilterPanel>
        <Loading isActive withIndicator />
      </FilterPanel>
    );
  }

  const {
    filters: { sections },
  } = context;
  if (!sections?.length) {
    return null;
  }
  /**
   * Function to return what to render based on tray type
   * @returns JSX.Element
   */
  const renderTrayComponent = () => {
    switch (trayType) {
      case 'segment_feature':
        return (
          <FeatureEditTrayComponent
            sections={sections}
            updateSettings={updateSettings}
            contextCustomFeature={contextCustomFeature}
          />
        );
      case 'segment_price':
        return (
          <EditTrayComponent
            sections={sections}
            updateSettings={updateSettings}
            currency={currency}
            quantityType={quantityType}
          />
        );
      default:
        return null;
    }
  };
  return renderTrayComponent();
}

export { EditTray };
